import './controls.scss';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { $state, $stateParams } from '../../router';

import RSVP_CONSTS from '../../constants';
import {
    GECKO_CONSTS,
    GeckoToastService,
    GeckoDialogService,
    GeckoBtn,
} from '@geckolabs/gecko-react-ui';
import Card from '../Card';

import {
    // updateAccount,
    // updateContact,
    // updateEvent,
    updateEventAttendance,
    replaceSessions, 
    replaceEvents,
} from '../../redux/actions';

import RsvpService from '../../services/RsvpService';
import Utils from '../../services/utils/utils';
import {__, STR_KEY} from '../../services/Translate';

class ComponentConfig extends Component {
    
    attendanceConfig = {
        [RSVP_CONSTS.ATTENDANCE.STATUS_INVITED] : {
            confirmText: __(STR_KEY.CONTROLS_ALERT_INVITE),
            waitlistText: __(STR_KEY.CONTROLS_ALERT_WAITLIST),
            confirmBtn: __(STR_KEY.CONTROLS_BTN_INVITE_YES),
            declineBtn: __(STR_KEY.CONTROLS_BTN_INVITE_NO),
            waitlistBtn: __(STR_KEY.CONTROLS_BTN_WAITLIST_YES),
            declineTracking: 'Reject invite clicked',
            confirmTracking: 'Accept invite clicked',
        },
    };

}

export class Controls extends ComponentConfig {

    rsvpService = new RsvpService();

    attendance() {
        return this.props.eventAttendance;
    }

    event() {
        return this.props.events && this.props.events.length ? this.props.events.find(e => !e.parent_id) : null;
    }

    isPassed() {
        return RsvpService.hasEventPassed(this.event());
    }

    isFull() {
        return this.event().full;
    }

    isClosed() {
        return RsvpService.hasEventClosed(this.event());
    }

    hasWaitlisting() {
        return this.event().auto_waitlist && !this.event().full_waitlist;
    }

    updateAttendance(going) {

        new GeckoDialogService().confirm(going ? __(STR_KEY.CONTROLS_DIALOG_REGISTER) : __(STR_KEY.CONTROLS_DIALOG_CANCEL)).then(confirm => {
            if (confirm) {

                const eventId = this.event().id;
                const attend = (going ? 'yes' : 'no');

                this.rsvpService.updateAttendance(eventId, attend).then((rsvpData) => {            
                    new GeckoToastService().success(going ? __(STR_KEY.CONTROLS_TOAST_REGISTER) : __(STR_KEY.CONTROLS_TOAST_CANCEL));
                    $state.go($state.$current.name, $stateParams, {reload: true})
                }).catch(err => new GeckoToastService().error(err));
                return;
            } 
        })
    }

    renderInvited() {
        const config = this.attendanceConfig[RSVP_CONSTS.ATTENDANCE.STATUS_INVITED];

        if (!this.isFull()){
            return (
                <div className="Controls InvitedStatus">
                    <Card className="basePlaceholder">
                        <div className="text-center">
                            <p>{config.confirmText}</p>
                            <div className="invited-buttons">
                                <GeckoBtn 
                                    name={config.declineBtn} 
                                    id="decline-invitation"
                                    type={GECKO_CONSTS.BTN_TYPE_DEFAULT} 
                                    icon="fa-times" 
                                    size="lg"
                                    handler={this.updateAttendance.bind(this, false, config.declineTracking)} />
                                <GeckoBtn 
                                    name={config.confirmBtn} 
                                    id="accept-invitation"
                                    type={GECKO_CONSTS.BTN_TYPE_PRIMARY} 
                                    icon="fa-check" 
                                    size="lg"
                                    handler={this.updateAttendance.bind(this, true, config.confirmTracking)} />
                            </div>
                        </div>
                    </Card>
                </div>
            );
        } else if (this.isFull() && this.hasWaitlisting()) {
            return (
                <div className="Controls WaitlistStatus">
                    <Card className="basePlaceholder">
                        <div className="text-center">
                            <p>{config.waitlistText}</p>
                            <div className="invited-buttons">
                                <GeckoBtn 
                                    name={config.declineBtn} 
                                    id="decline-waitlist"
                                    type={GECKO_CONSTS.BTN_TYPE_DEFAULT} 
                                    icon="fa-times" 
                                    size="lg"
                                    handler={this.updateAttendance.bind(this, false, config.declineTracking)} />
                                <GeckoBtn 
                                    name={config.waitlistBtn} 
                                    id="accept-waitlist"
                                    type={GECKO_CONSTS.BTN_TYPE_PRIMARY} 
                                    icon="fa-check" 
                                    size="lg"
                                    handler={this.updateAttendance.bind(this, true, config.waitlistBtn)} />
                            </div>
                        </div>
                    </Card>
                </div>
            );
        }

        return null;
    }

    render() {
        if (this.isPassed() || this.isClosed()) {
            return null;
        }

        if (!this.attendance().status || this.attendance().status === RSVP_CONSTS.ATTENDANCE.STATUS_INVITED && !this.event().checkin_started) {
            return this.renderInvited();
        }

        return null;        
    }
}

const mapStateToProps = (store) => {
    return {
        account: store.account,
        contact: store.contact,
        eventAttendance: store.eventAttendance,
        events: store.events,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateStore: (data) => {
            // dispatch(updateAccount(data.account));
            // dispatch(updateContact(data.contact));
            dispatch(replaceEvents(data.events));
            dispatch(updateEventAttendance(data.eventAttendance));
            dispatch(replaceSessions(data.sessions));
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Controls)